import wrapper from 'wrapper';
import * as d3Select from 'd3-selection';

const d3 = { ...d3Select/* , ...d3Transition, ...d3Interpolate */ };

class PanelSlider {
    constructor(container) {
        this.container = d3.select(container);
        this.panelTwoButtons = this.container.selectAll('.panel-two-buttons button.section');
        this.panelTwoContent = this.container.selectAll('.panel-two .section-content');
        this.panelOne = this.container.select('.panel-one');
        this.panelTwo = this.container.select('.panel-two');
        this.isMobile = true;

        this.container.select('.panel-one-buttons')
            .selectAll('button')
            .on('click', (d, i) => this.goToPanelTwo(i));

        this.container.select('.panel-two-buttons')
            .selectAll('button.section')
            .on('click', (d, i) => this.goToPanelTwo(i));

        this.container.select('.panel-two .back-button')
            .on('click', () => {
                wrapper.trackClick('Back button pressed');
                this.switchMenu(false);
            });

        this.container.select('#party-content-pfp--basic_info')
            .on('change', () => {
                wrapper.trackClick('Basic info for Lee Jae-Myung pressed');
            });

        this.container.select('#party-content-pfp--slogan')
            .on('change', () => {
                wrapper.trackClick('Slogan for Lee Jae-Myung pressed');
            });

        this.container.select('#party-content-pfp--manifesto')
            .on('change', () => {
                wrapper.trackClick('Manifesto for Lee Jae-Myung pressed');
            });

        this.container.select('#party-content-pfp--supporters')
            .on('change', () => {
                wrapper.trackClick('Key agenda for Lee Jae-Myung pressed');
            });

        this.container.select('#party-content-kmt--basic_info')
            .on('change', () => {
                wrapper.trackClick('Basic info for Yoon Seok-Youl pressed');
            });

        this.container.select('#party-content-kmt--slogan')
            .on('change', () => {
                wrapper.trackClick('Slogan for Yoon Seok-Youl pressed');
            });

        this.container.select('#party-content-kmt--manifesto')
            .on('change', () => {
                wrapper.trackClick('Manifesto for Yoon Seok-Youl pressed');
            });

        this.container.select('#party-content-kmt--supporters')
            .on('change', () => {
                wrapper.trackClick('Key agenda for Yoon Seok-Youl pressed');
            });

        if (window.matchMedia('(min-width: 800px)').matches) {
            this.isMobile = false;
        }

        this.resizeIframe();
        this.switchMenu(false);
    }

    resizeIframe() {
        const containingBox = wrapper.select('.panel-two');
        const buttons = containingBox.querySelector('.panel-two-buttons');
        const content = containingBox.querySelector('.panel-two-content');
        const panelTwoHeight = () => {
            return gbc(buttons).height + gbc(content).height;
        };

        ResizeObserver(() => {
            this.container.style('height', `${panelTwoHeight()}px`);
        }).observe(content);
    }

    goToPanelTwo(i) {
        const trackLabel = i ? 'Yoon Seok-Youl' : 'Lee Jae-Myung';
        wrapper.trackClick(`${trackLabel} chosen`);
        Array.from(this.container.node().querySelectorAll('.panel-two-button'))
            .forEach(btn => btn.removeAttribute('tabindex'));
        this.container.node().querySelector('.back-button').removeAttribute('tabindex');
        this.panelTwoButtons.classed('selected', (e, j) => (j === i));
        this.panelTwoContent.classed('selected', (e, j) => (j === i));
        this.switchMenu(true);
    }

    switchMenu(isCategory) {
        this.panelOne.classed('selected', !isCategory);
        this.panelTwo.classed('selected', isCategory);

        if (!isCategory) {
            this.panelTwoContent.classed('selected', false);
            Array.from(this.container.node().querySelectorAll('.panel-two-button'))
                .forEach(btn => btn.setAttribute('tabindex', -1));
            this.container.node().querySelector('.back-button').setAttribute('tabindex', -1);
        }
    }
}

function ResizeObserver(callback) {
    if ('ResizeObserver' in window) {
        // the best
        return new window.ResizeObserver(callback);
    }

    // fallback with raf (idk the polyfill doesn't work)
    // WARNING the spec can observe multiple elements, this one can only observe one.
    return {
        observe(element) {
            let lastHeight = gbc(element).height;
            observe(
                () => {
                    const newHeight = gbc(element).height;
                    if (lastHeight !== newHeight) {
                        lastHeight = newHeight;
                        return true;
                    }
                    return false;
                },
                callback,
            );
        },
    };
}

function gbc(element) {
    return element.getBoundingClientRect();
}

function observe(valueFn, callbackFn) {
    const obsFn = () => {
        if (valueFn()) {
            callbackFn();
        }
        window.requestAnimationFrame(obsFn);
    };
    window.requestAnimationFrame(obsFn);
}

export default PanelSlider;
